<div [ngClass]="{'kgrid-fullscreen' : enableFullscreen }">
  <kendo-grid #grd [kendoGridBinding]="_DataList" [sortable]="true" [resizable]="true" [filterable]="enableFilter" [reorderable]="true" [pageSize]="15" [pageable]="true">
      <ng-template kendoPagerTemplate>
          <div class="k-pager-left">
              <kendo-pager-info></kendo-pager-info>
          </div>
          <div class="k-pager-right">
              <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
              <kendo-pager-input></kendo-pager-input>
              <kendo-pager-next-buttons></kendo-pager-next-buttons>
          </div>
      </ng-template>
      <ng-template kendoGridToolbarTemplate>
          <div class="k-grid-toolbar-content d-flex">
              <div class="flex-grow-1 mat-panel-headerbar"></div>
              <div class="divider-container d-none d-md-block" id="imgDivider">
                  <span></span>
              </div>
              <div class="pagination-container">
                  <p id="lblShowDetails">Show</p>
                  <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                  </kendo-pager-page-sizes>
                  <span>Items</span>
              </div>
              <div class="divider-container d-none d-md-block" id="imgDivider">
                  <span></span>
              </div>
              <div class="icons-container">
                  <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
                  <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">
                      <div class="icon-wrap" (click)="toggleFilter()">
                          <i class="fa fa-filter" title="Filter" aria-hidden="true"></i>
                          <span class="list-icon-name">Filter</span>
                      </div>
                      <div class="icon-wrap" (click)="gridSettings()">
                          <i class="fa fa-cog" title="Settings" aria-hidden="true"></i>
                          <span class="list-icon-name">Grid Settings</span>
                      </div>
                      <div class="icon-wrap" (click)="toggleFullscreen()">
                          <i class="fa " [ngClass]="enableFullscreen ? 'fa-compress': ' fa-expand'" aria-hidden="true" title="{{ !enableFullscreen ? 'Expand' : 'Collapse' }}"></i>
                          <span class="list-icon-name">{{ !enableFullscreen ? 'Expand' : 'Collapse' }}</span>
                      </div>
                  </div>
                  <div class="divider-container"><span></span></div>
                  <ng-container *ngFor="let reportColumn of  GridHeaderIcons">
                      <i  class="{{reportColumn.class}}" aria-hidden="true"  title="{{reportColumn.title}}" (click)="IconClick(reportColumn)"></i>
                  </ng-container>
              </div>
          </div>
      </ng-template>
      <kendo-grid-column *ngFor="let column of grdSettings let i = index" [width]="column.width" field="{{column.field}}" title="{{column.title}}">
      </kendo-grid-column>
      <kendo-grid-column title="Action" width="80" class="text-center">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              <ng-container *ngFor="let reportColumn of  GridListIcons">
                  <i *ngIf="Visible(reportColumn,dataItem)"  class="{{reportColumn.class}}" aria-hidden="true"  title="{{reportColumn.title}}" (click)="IconClick(reportColumn,dataItem)"></i>
              </ng-container>
          </ng-template>
      </kendo-grid-column>
  </kendo-grid>
</div>